import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import createHistory from 'history/createBrowserHistory';
import 'bootstrap/dist/css/bootstrap.css';
import './styles/index.css';
import App from './App';
import configureStore from './redux/store';
import Authentication from './modules/auth/authentication';
import config from 'react-global-configuration';

config.set({ 
  enable_authentication: true
});

// send auth headers with every (axios-based) xhr request
const authentication = new Authentication();
authentication.installAuthInterceptor();

const history = createHistory();
const { store } = configureStore(history);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js